"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Link = _antd.Anchor.Link;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Anchor, null, /*#__PURE__*/_react.default.createElement(Link, {
    href: "#",
    title: "Basic demo"
  }), /*#__PURE__*/_react.default.createElement(Link, {
    href: "#components-anchor-demo-static",
    title: "Static demo"
  }), /*#__PURE__*/_react.default.createElement(Link, {
    href: "#API",
    title: "API"
  }, /*#__PURE__*/_react.default.createElement(Link, {
    href: "#Anchor-Props",
    title: "Anchor Props"
  }), /*#__PURE__*/_react.default.createElement(Link, {
    href: "#Link-Props",
    title: "Link Props"
  }))));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorSplit', 'colorBgContainer'],
  key: 'anchor'
};
var _default = exports.default = componentDemo;